import { render, staticRenderFns } from "./ProductionMonitoring.vue?vue&type=template&id=6196abe8&scoped=true&"
import script from "./ProductionMonitoring.vue?vue&type=script&lang=js&"
export * from "./ProductionMonitoring.vue?vue&type=script&lang=js&"
import style0 from "./ProductionMonitoring.css?vue&type=style&index=0&id=6196abe8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6196abe8",
  null
  
)

export default component.exports